module.exports = __webpack_public_path__ + "static/media/Raggiungimi 1.0671f975.png";